import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const IoT = () => {
  

  const features = [
    {
      title: '빠른 개폐 속도',
      bullets: [
      {
        label: (
          <>고속도로 환경에 최적화된 모터 시스템을 적용하여 차량 흐름을 지연 없이 관리</>
        ),
      },
      ]
    },
    {
      title: '높은 내구성',
      bullets: [
      {
        label: (
          <>외부 환경(비, 눈, 먼지, 고온 등)에 강한 소재로 제작되어 장기간 안정적인 사용이 가능함</>
        ),
      },
      ]
    },
    {
      title: '안전 센서 적용',
      bullets: [
      {
        label: (
          <>차량 접근 감지 센서와 안전 장치가 내장되어 있어, 차량 및 보행자 안전을 최우선으로 보호</>
        ),
      },
      ]
    },
    {
      title: '간편한 유지보수',
      bullets: [
      {
        label: (
          <>모듈형 설계로 부품 교체 및 점검이 용이하여 관리 비용과 시간을 절감</>
        ),
      },
      ]
    },
    {
      title: '스마트 제어 시스템',
      bullets: [
      {
        label: (
          <>원격 모니터링 및 제어 기능을 제공하여 도로 관리자가 실시간으로 상태를 확인하고 조작할 수 있음</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`IoT 회차로 차단제어기`}
        subtitle={`원격으로 차단기를 제어하여 \n회차 구간의 안전 사고를 예방합니다`}
        backgroundImage="/images/products/guardrail/IoT6.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: 'IoT 회차로 차단제어기' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`원격 회차 지원으로 안전 사고 예방을`}
        title={`IoT 회차로 차단제어기`}
        description={
          <>
            고속도로에 잘못 진입한 차량이 안전하게 회차할 수 있도록 지원하는 회차로 차단기를 무선 리모콘을 통해 {' '}
            작업자가 안전한 거리에서 원격으로 차단기를 제어할 수 있어 현장 작업자의 안전성을 크게 향상시킵니다.
            <br />
            <br />
            회차 구간에서의 안전 사고를 예방하여 운전자와 도로 관리자의 안전을 동시에 지켜줍니다.
          </>
        }
        images={[
          '/images/products/guardrail/IoT5.jpg',
          '/images/products/guardrail/IoT6.jpg',
          '/images/products/guardrail/IoT2.jpg',
          '/images/products/guardrail/IoT3.png',
          '/images/products/guardrail/IoT4.jpg',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>


      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/IoT"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default IoT;
